export const PROJECTS_ROUTE = '/projects'
export const BLOG_ROUTE = '/articles'
export const SERVICES_ROUTE = '/services'
export const EVENTS_ROUTE = '/events'


export const MAIN_PAGE_ROUTE = '/:lang'
export const PROJECTS_PAGE_ROUTE = '/:lang/projects'
export const PROJECTS_DETAIL_PAGE_ROUTE = '/:lang/projects/:slug'
export const SERVICES_PAGE_ROUTE = '/:lang/services'
export const SERVICES_DETAIL_PAGE_ROUTE = '/:lang/services/:slug'

export const SAMPLE_PAGE_SOUTE = '/:lang/page/:slug'


export const ARTICLE_PAGE_ROUTE = '/:lang/articles'
export const ARTICLE_DETAIL_PAGE_ROUTE = '/:lang/articles/:slug'


export const ABOUT_PAGE_ROUTE = '/:lang/about'

export const BLOG_RIGHT_SIDEVAR = "/blog/right-sidebar"
export const FAQ_PAGE_ROUTE = '/faq'


export const CONTACTS_PAGE_ROUTE = '/contacts'
export const EVENTS_PAGE_ROUTE = '/:lang/events'
export const ERROR_PAGE_ROUTE = '/error'
export const EVENT_DETAIL_PAGE_ROUTE = '/:lang/events/:slug'

export const MEDIA_PAGE_ROUTE = '/:lang/media'
export const MEDIA_DETAIL_PAGE_ROUTE = '/:lang/media/:slug'